import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Notifications from '../../notifications'
import dataLoad from '../../../actions/data-load';
import {appNotificationViewed} from '../../../actions/app-notifications'

function mapStateToProps(state) {
    // console.log('state ====>', state);
    return {
        notifications: state.notifications,
        ajaxStatuses: state.ajaxStatuses.dataLoad,
        user: state.user,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        dataLoad,
        appNotificationViewed
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Notifications);